export const getUnbrokenEmDashText = text => (
    text.replace(/—/g, '\u2060—')
)
